import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useCMSPage = (slug, defaults = {}) => {
  const [fields, setFields] = useState(defaults);
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [pageExists, setPageExists] = useState(false);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const res = await axios.get(`${API}/pages/${slug}`);
        const page = res.data;
        if (page && page.is_published !== false) {
          // Merge CMS fields over defaults — only override non-empty values
          const merged = { ...defaults };
          if (page.fields) {
            Object.entries(page.fields).forEach(([key, value]) => {
              if (value !== undefined && value !== null && value !== "") {
                merged[key] = value;
              }
            });
          }
          setFields(merged);
          setContent(page.content || "");
          setPageExists(true);
        }
      } catch (err) {
        console.debug("No CMS page found, using defaults:", err);
      }
      setLoading(false);
    };
    fetchPage();
  }, [slug]);

  return { fields, content, loading, pageExists };
};
